import { IInternJuridiskUnderkonsulentRapport } from "../reportSchemas/internJuridiskSchema.js";

export const INTERN_JURIDISK_UNDERKONSULENT_INIT_DATA: IInternJuridiskUnderkonsulentRapport = {
  generellInfo: {
    prosjektNavn: "",
    oppdragsBeskrivelse: "",
    underkonsulent: {
      navn: "",
      orgNummer: "",
      adresse: "",
      representant: {
        navn: "",
        tittel: "",
        kontaktDetaljer: {
          email: "",
          tlf: "",
        },
      },
    },
    multiRepresentant: {
      navn: "",
      tittel: "",
      kontaktDetaljer: {
        email: "",
        tlf: "",
      },
    },
    dato: "",
    sted: "",
  },
  avtaleDokumenter: {
    avtaleC: false,
    avtaleD: false,
    avtaleE: "",
  },
  underkonsulentensNokkelpersoner: {
    isActive: false,
    nokkelpersoner: [
      {
        navn: "",
        fagdisiplin: "",
      },
    ],
  },
  dagmulktEllerErstatning: {
    altEn: false,
    altTo: false,
    dagmulktBelagteFrister: [
      {
        frist: "",
        sats: "2 ‰ av kontraktssum eller antatt totalt honorar eks. mva., minimum 1000 kr",
      },
    ],
  },
  ansvarsbegrensninger: {
    forsinkelse: {
      altEn: true,
      altTo: false,
      bestemmelser: "",
    },
    prosjekteringsfeil: {
      altEn: true,
      altTo: false,
      bestemmelser: "",
    },
  },
  ovrigeBestemmelser: false,
  vedlegg: {
    vedleggA: {
      isActive: true,
      beskrivelse: "",
    },
    vedleggB: {
      isActive: true,
      beskrivelse: "",
    },
    vedleggC: {
      isActive: true,
      beskrivelse: "",
    },
    vedleggD: {
      isActive: true,
      beskrivelse: "",
    },
    vedleggE: {
      isActive: true,
      beskrivelse: "",
    },
  },
};
